module.exports = __webpack_public_path__ + "static/media/unicef_logo.0dd85879.svg";